import { memo } from "react";

function InterviewScreenRightSidebarSkeleton() {
  return (
    <aside className="h-full border-l bg-white p-4 overflow-y-auto space-y-4 animate-pulse">
      {/* Name and Role */}
      <div className="space-y-2">
        <div className="w-32 h-5 bg-gray-200 rounded" /> {/* Name */}
        <div className="w-24 h-4 bg-gray-200 rounded" /> {/* Role */}
        <div className="w-16 h-5 bg-gray-200 rounded mt-1" />
        {/* Status Badge */}
      </div>

      {/* Interview Info */}
      <div className="flex justify-between text-sm space-x-2">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-gray-200 rounded" /> {/* Calendar Icon */}
          <div className="w-16 h-3 bg-gray-200 rounded" /> {/* Date */}
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-gray-200 rounded" /> {/* Clock Icon */}
          <div className="w-12 h-3 bg-gray-200 rounded" /> {/* Duration */}
        </div>
      </div>

      {/* Resume Match */}
      <div className="flex items-center justify-between">
        <div className="w-16 h-4 bg-gray-200 rounded" /> {/* JD Match Label */}
        <div className="w-10 h-10 bg-gray-200 rounded-full" />{" "}
        {/* Progress Circle */}
      </div>

      {/* Attachments */}
      <div className="space-y-2">
        <div className="w-24 h-4 bg-gray-200 rounded" />{" "}
        {/* Attachments Label */}
        <div className="w-full h-12 bg-gray-200 rounded-lg" />{" "}
        {/* Resume attachment */}
      </div>

      {/* Interview Feedback */}
      <div className="space-y-2">
        <div className="w-32 h-4 bg-gray-200 rounded" /> {/* Feedback Label */}
        {Array.from({ length: 3 }).map((_, idx) => (
          <div key={idx} className="space-y-1">
            <div className="flex justify-between">
              <div className="w-20 h-3 bg-gray-200 rounded" />{" "}
              {/* Rating label */}
              <div className="w-8 h-3 bg-gray-200 rounded" />{" "}
              {/* Rating value */}
            </div>
            <div className="flex gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <div
                  key={i}
                  className="w-4 h-4 bg-gray-200 rounded"
                /> /* Stars */
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Strengths */}
      <div className="space-y-1">
        <div className="w-24 h-4 bg-gray-200 rounded" /> {/* Strengths Label */}
        <div className="flex gap-2 flex-wrap">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="w-20 h-6 bg-gray-200 rounded-full" />
          ))}
        </div>
      </div>

      {/* Areas for Improvement */}
      <div className="space-y-1">
        <div className="w-36 h-4 bg-gray-200 rounded" />{" "}
        {/* Improvement Label */}
        <div className="flex gap-2 flex-wrap">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="w-24 h-6 bg-gray-200 rounded-full" />
          ))}
        </div>
      </div>

      {/* Additional Attachments */}
      <div className="space-y-2">
        {Array.from({ length: 2 }).map((_, idx) => (
          <div key={idx} className="w-full h-12 bg-gray-200 rounded-lg" />
        ))}
      </div>
    </aside>
  );
}

export default memo(InterviewScreenRightSidebarSkeleton);
